import {ReactNode, useMemo} from "react";
import {FormDataCadastro} from "../../_pages/PageCadastro";
import {Formik, Form, Field, ErrorMessage} from "formik";
import InputMask from "react-input-mask";
import * as Yup from 'yup';
import {validateCpf} from "../../_util/StringUtil";

interface PropsVerificar {
    onSubmit: (body: FormDataCadastro) => void;
    initial?: FormDataCadastro;
    children?: ReactNode
}


export default function FormCadastroVerificar(
    {onSubmit, initial = {} as FormDataCadastro, children = null}: PropsVerificar
) {
    const initialValues = useMemo<Partial<FormDataCadastro>>(() => ({
        ...{cpf: '', data_nascimento: ''},
        ...initial
    }), []);

    const validationSchema = useMemo(() => Yup.object().shape({
        cpf: Yup.string().matches(/\d{3}\.\d{3}\.\d{3}-\d{2}/gi)
            .test('cpf', 'CPF inválido', (value) => validateCpf(value))
            .required(),
        data_nascimento: Yup.string().required()
    }), []);

    function handleSubmit(v: FormDataCadastro) {
        onSubmit(v);
    }

    return <>
        <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema} >
            <Form className="d-flex flex-column gap-2">
                <div className="form-outline mb-4">
                    <label htmlFor="cpf" className={'form-label'}>CPF</label>
                    <Field as={InputMask} id="cpf" name="cpf" className="form-control form-control-lg"
                           mask="999.999.999-99" maskChar='' required placeholder={'CPF'}/>
                    <ErrorMessage name="cpf" component="small" className="text-danger"/>
                </div>
                <div className="form-outline mb-4">
                    <label htmlFor="data_nascimento" className={'form-label'}>Data de Nascimento</label>
                    <Field id="data_nascimento" name="data_nascimento" className="form-control form-control-lg"
                           type="date" required placeholder={'dd/mm/aaaa'}/>
                    <ErrorMessage name="data_nascimento" component="small" className="text-danger"/>
                </div>

                <div className="text-center text-lg-start mt-4 pt-2">
                    <button type="submit" className="btn btn-sesc-blue btn-block text-light w-100 btn-lg">
                        <i className="fa fa-search"/> Verificar
                    </button>
                </div>
            </Form>
        </Formik>
        {children}
    </>;
}